export default {
  "header": "_header_iwvrl_1"
};import "/tmp/202335-27-40bk9m.2ywvh.css";